import { provideApolloClient } from '@vue/apollo-composable';

export default defineNuxtPlugin(() => {
  const { clients } = useApollo();
  
  provideApolloClient(clients!.default);

  return{
    provide: {
      apolloClient: clients.default
    }
  };
});